import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL, ATTACH_SERVER } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import ReactTable from "react-table";
// @ts-ignore
import Rodal from "rodal";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
var qs = require("qs");
var ThemesToOffer = /** @class */ (function (_super) {
    tslib_1.__extends(ThemesToOffer, _super);
    function ThemesToOffer(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            searching: false,
            themes: [],
            page: 0,
            pageSize: 20,
            loading: true,
            currentTheme: { title: '', id: null, file_id: null, icon: '', type: '', theme_id: null },
            showRodal: false,
            themeList: [],
            filterThemes: [],
        };
        return _this;
    }
    ThemesToOffer.prototype.componentWillMount = function () {
        this.getThemes();
    };
    ThemesToOffer.prototype.render = function () {
        var _this = this;
        var columns = [{
                Header: '#',
                accessor: 'id',
                width: 100,
                style: { textAlign: 'center' }
            }, {
                Header: 'Заголовок',
                accessor: 'title',
            }, {
                Header: 'Управление',
                sortable: false,
                width: 150,
                style: { textAlign: 'center' },
                Cell: function (props) {
                    return (React.createElement("div", { className: "btn-group" },
                        React.createElement("button", { onClick: function () { return _this.setState(function (prevState) {
                                var cc = prevState.currentTheme;
                                cc.id = props.row._original.id;
                                cc.title = props.row._original.title;
                                return { showRodal: true, currentTheme: cc };
                            }); }, type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-thumbs-up" })),
                        React.createElement("button", { onClick: _this.changeStatus.bind(_this, props.row._original.id, 'decline'), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-thumbs-down" }))));
                }
            }];
        return (React.createElement(React.Fragment, null,
            React.createElement(Rodal, { onClose: function () {
                    _this.setState({ showRodal: false, currentTheme: { title: '', id: null, file_id: null, icon: '', type: '', theme_id: null } });
                }, visible: this.state.showRodal, width: 400, height: 400 },
                React.createElement("div", { className: "form-group" },
                    "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A",
                    React.createElement("input", { disabled: true, className: "form-control cols-xs-12", style: { width: '100%' }, name: "name", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState(function (prevState) {
                                var cc = prevState.currentTheme;
                                cc.title = value;
                                return { currentTheme: cc };
                            });
                        }, value: this.state.currentTheme.title, type: "text" })),
                React.createElement("div", { className: "form-group" },
                    "\u0422\u0438\u043F",
                    React.createElement("select", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "name", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState(function (prevState) {
                                var cc = prevState.currentTheme;
                                cc.type = value;
                                return { currentTheme: cc };
                            });
                        }, value: this.state.currentTheme.type },
                        React.createElement("option", { value: '' }, "\u041D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D"),
                        React.createElement("option", { value: 'theme' }, "\u0422\u0435\u043C\u0430"),
                        React.createElement("option", { value: 'subtheme' }, "\u041F\u043E\u0434\u0442\u0435\u043C\u0430"))),
                this.state.currentTheme.type === 'theme' && (React.createElement("div", { className: "form-group" },
                    "\u0418\u043A\u043E\u043D\u043A\u0430",
                    React.createElement("br", null),
                    this.state.currentTheme.icon.length > 0 && (React.createElement("img", { width: "50", height: "50", src: this.state.currentTheme.icon })),
                    React.createElement("input", { type: 'file', accept: 'image/png', onChange: function (e) {
                            if (e.target.files) {
                                _this.handleChange(e.target.files);
                            }
                            e.target.value = '';
                        } }))),
                this.state.currentTheme.type === 'subtheme' && (React.createElement("div", { className: 'form-group' },
                    React.createElement(AsyncTypeahead, { isLoading: this.state.themeLoading, labelKey: "title", options: this.state.themeList, selected: this.state.filterThemes, multiple: false, onChange: function (filterThemes) {
                            _this.setState(function (prevState) {
                                var cc = prevState.currentTheme;
                                cc.theme_id = filterThemes && filterThemes[0] ? filterThemes[0].id : null;
                                return { filterThemes: filterThemes, currentTheme: cc };
                            });
                        }, onSearch: function (query) {
                            _this.setState({ themeLoading: true });
                            fetch(API_URL + "/themes?query=" + query)
                                .then(function (resp) { return resp.json(); })
                                .then(function (json) { return _this.setState({
                                themeLoading: false,
                                themeList: json.data,
                            }, function () { return console.log(_this.state.themeList); }); });
                        } }))),
                React.createElement("button", { type: 'button', onClick: this.changeStatus.bind(this, this.state.currentTheme.id, 'approve'), className: "btn btn-primary btn-lg btn-block", style: { color: '#fff' } }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(ReactTable, { previousText: '\u041D\u0430\u0437\u0430\u0434', nextText: '\u0412\u043F\u0435\u0440\u0435\u0434', loadingText: 'Loading...', noDataText: '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', pageText: '\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430', ofText: '\u0438\u0437', rowsText: '\u0441\u0442\u0440\u043E\u043A', page: this.state.page, pages: Math.ceil(this.state.pages / this.state.pageSize), loading: this.state.loading, minRows: 1, manual: true, onPageChange: this.nextPage.bind(this), onSortedChange: this.onSort.bind(this), onPageSizeChange: this.onPageSize.bind(this), data: this.state.themes, columns: columns })))));
    };
    ThemesToOffer.prototype.getThemes = function () {
        var _this = this;
        this.setState({ loading: true });
        var searchString = 'page=' + (this.state.page + 1) + '&sort=' + this.state.sort + '&limit=' + this.state.pageSize;
        axios.get(API_URL + '/themes-to-offer?' + searchString, {
            headers: { 'Authorization': this.props.auth_token }
        }).then(function (resp) {
            _this.setState({
                themes: resp.data.data ? resp.data.data : [], pages: resp.data.meta.total,
                loading: false
            });
        }).catch(function (error) {
            if (error.response && error.response.status === 403) {
                toastr.error('Ошибка', 'У Вас недостаточно прав');
            }
        });
    };
    ThemesToOffer.prototype.nextPage = function (page) {
        var _this = this;
        this.setState({ page: page }, function () { return _this.getThemes(); });
    };
    ThemesToOffer.prototype.onSort = function (sort) {
        var _this = this;
        this.setState({ sort: sort[0].desc ? '-' + sort[0].id : sort[0].id }, function () { return _this.getThemes(); });
    };
    ThemesToOffer.prototype.onPageSize = function (pageSize) {
        var _this = this;
        this.setState({
            pageSize: pageSize,
            page: 0,
        }, function () {
            _this.getThemes();
        });
    };
    ThemesToOffer.prototype.changeStatus = function (id, status) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите изменить статус предложенной темы?');
        var data = {};
        if (status === 'decline') {
            data = { status: status };
        }
        if (status === 'approve' && this.state.currentTheme.type === 'subtheme' && !this.state.currentTheme.theme_id) {
            toastr.error('Ошибка', 'Выберите тему из списка');
            return;
        }
        if (status === 'approve') {
            data = { type: this.state.currentTheme.type, title: this.state.currentTheme.title, file_id: this.state.currentTheme.file_id, theme_id: this.state.currentTheme.theme_id };
        }
        if (result) {
            axios.post(API_URL + '/theme-to-offer/confirm/' + id, qs.stringify(data), {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.setState({ showRodal: false, currentTheme: { title: '', id: null, file_id: null, icon: '', type: '', theme_id: null }, }, function () {
                    _this.getThemes();
                });
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    ThemesToOffer.prototype.handleChange = function (files) {
        var _this = this;
        var file = files[0];
        var height = 0;
        var width = 0;
        if (file.type !== "image/png") {
            alert("Изображение должно быть png формата");
            return;
        }
        var img = new Image();
        img.onload = function () {
            height = img.height;
            width = img.width;
            if (width !== height) {
                alert("Изображение должно быть равносторонним.");
                return;
            }
            var data = new FormData();
            data.append('upload', file);
            axios.post(ATTACH_SERVER + '/upload/', data, {
                headers: {
                    'Authorization': 'Bearer ' + _this.props.auth_token,
                },
            })
                .then(function (res) {
                _this.setState(function (prevState) {
                    var cc = prevState.currentTheme;
                    cc.icon = res.data.data.link_to_thumb;
                    cc.file_id = res.data.data.id;
                    return { currentTheme: cc };
                });
            })
                .catch(function (err) {
                if (err.response && err.response.data && err.response.data.error) {
                    toastr.error('Ошибка', err.response.data.error);
                }
            });
        };
        img.src = URL.createObjectURL(files[0]);
    };
    return ThemesToOffer;
}(React.Component));
export default connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(ThemesToOffer);



//////////////////
// WEBPACK FOOTER
// ./src/views/themestooffer/index.tsx
// module id = 538
// module chunks = 0